/**
 * Shared category → hex color mapping.
 * Import getCategoryColor() wherever you need to color a transaction category.
 * This single source of truth keeps the pie chart, transaction chips,
 * and any future components pixel-for-pixel consistent.
 */

export const CATEGORY_COLORS = {
  // Income / transfers
  'Income':              '#2e7d32',
  'Transfer':            '#616161',
  'Credit Card Payment': '#5d4037',
  'Savings':             '#1565c0',

  // Giving
  'Charity/Donation':    '#43a047',
  'Family Support':      '#9c27b0',
  'Reimbursement':       '#e65100',

  // Food
  'Food & Dining':       '#388e3c',
  'Groceries':           '#558b2f',
  'Dining Out':          '#ef6c00',

  // Transport / home
  'Transport':           '#f57c00',
  'Gas':                 '#ff7043',
  'Auto':                '#78909c',
  'Housing':             '#455a64',

  // Bills / services
  'Utilities':           '#0097a7',
  'Subscriptions':       '#7b1fa2',
  'Insurance':           '#c2185b',
  'Fees':                '#b71c1c',
  'Fees & Charges':      '#b71c1c',

  // Health / personal
  'Healthcare':          '#d32f2f',
  'Health & Fitness':    '#00838f',
  'Personal Care':       '#6a1b9a',

  // Shopping / lifestyle
  'Shopping':            '#1976d2',
  'Entertainment':       '#f06292',
  'Travel':              '#26a69a',
  'Education':           '#8d6e63',

  // Investing
  'Investments':         '#4527a0',

  // Catch-alls
  'Uncategorized':       '#9e9e9e',
  'Other':               '#546e7a',
};

/**
 * Fallback palette used when a category is not in CATEGORY_COLORS.
 * Colors cycle by index so new/unknown categories still get distinct colors.
 */
const FALLBACK_PALETTE = [
  '#1976d2', '#388e3c', '#f57c00', '#d32f2f', '#7b1fa2',
  '#0097a7', '#c2185b', '#455a64', '#827717', '#4a148c',
  '#00695c', '#e65100', '#1565c0', '#4e342e', '#37474f',
];

/**
 * Returns the canonical hex color for a category.
 * @param {string|null|undefined} category
 * @param {number} [index=0]  fallback cycling index (use the array position of the item)
 */
export function getCategoryColor(category, index = 0) {
  if (!category) return FALLBACK_PALETTE[index % FALLBACK_PALETTE.length];
  return CATEGORY_COLORS[category] ?? FALLBACK_PALETTE[index % FALLBACK_PALETTE.length];
}
